// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__6yXPT","bigColWidth":"Table_bigColWidth__1olLh","biggerColWidth":"Table_biggerColWidth__2oDXE","row":"Table_row__2n-Gg","col":"Table_col__3Lyqt"};